// extracted by mini-css-extract-plugin
module.exports = {"headContent":"CatchAllTemplate_headContent__Vvhwn","rotation":"CatchAllTemplate_rotation__eYcG1","preventivoBoxBubble":"CatchAllTemplate_preventivoBoxBubble__VOjnC"};